module.exports = __webpack_public_path__ + "static/img/2022.01f7708.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2022.png
// module id = ylD3
// module chunks = 1